export type OAuthClaimNext = "connected" | "choose";
export type OAuthPickerPlatform = "meta_ads" | "google_ads" | "microsoft_ads";

export interface OAuthClaimProvider {
  statusKey: string;
  tokenKey: string;
  platform: string;
  label: string;
  defaultNext: OAuthClaimNext;
  pickerPlatform?: OAuthPickerPlatform;
}

export const OAUTH_CLAIM_PROVIDERS: readonly OAuthClaimProvider[] = [
  { statusKey: "meta_oauth", tokenKey: "meta_claim", platform: "meta_ads", label: "Meta Ads", defaultNext: "choose", pickerPlatform: "meta_ads" },
  { statusKey: "shopify_oauth", tokenKey: "shopify_claim", platform: "shopify", label: "Shopify", defaultNext: "connected" },
  { statusKey: "tiktok_oauth", tokenKey: "tiktok_claim", platform: "tiktok_ads", label: "TikTok Ads", defaultNext: "connected" },
  { statusKey: "google_ads_oauth", tokenKey: "google_ads_claim", platform: "google_ads", label: "Google Ads", defaultNext: "choose", pickerPlatform: "google_ads" },
  { statusKey: "google_analytics_oauth", tokenKey: "google_analytics_claim", platform: "google_analytics", label: "Google Analytics", defaultNext: "connected" },
  { statusKey: "microsoft_ads_oauth", tokenKey: "microsoft_ads_claim", platform: "microsoft_ads", label: "Microsoft Ads", defaultNext: "choose", pickerPlatform: "microsoft_ads" },
  { statusKey: "linkedin_ads_oauth", tokenKey: "linkedin_ads_claim", platform: "linkedin_ads", label: "LinkedIn Ads", defaultNext: "connected" },
  { statusKey: "pinterest_oauth", tokenKey: "pinterest_claim", platform: "pinterest_ads", label: "Pinterest Ads", defaultNext: "connected" },
  { statusKey: "snapchat_oauth", tokenKey: "snapchat_claim", platform: "snapchat_ads", label: "Snapchat Ads", defaultNext: "connected" },
  { statusKey: "quickbooks_oauth", tokenKey: "quickbooks_claim", platform: "quickbooks", label: "QuickBooks", defaultNext: "choose" },
  { statusKey: "xero_oauth", tokenKey: "xero_claim", platform: "xero", label: "Xero", defaultNext: "connected" },
  { statusKey: "freshbooks_oauth", tokenKey: "freshbooks_claim", platform: "freshbooks", label: "FreshBooks", defaultNext: "connected" },
] as const;

export function oauthClaimNext(
  provider: OAuthClaimProvider,
  responseNext?: OAuthClaimNext,
): OAuthClaimNext {
  // Claiming a QuickBooks login is not the business/company confirmation.
  if (provider.platform === "quickbooks") return "choose";
  return responseNext ?? provider.defaultNext;
}
